import React from "react"

import { withArticleBanner } from "./withArticleBanner"
import { StyledContainer } from "../../Styled/Container"
import { Banner, Image, Title } from "./ArticleBannerStyles"

export const ArticleBanner = withArticleBanner(
  ({ title, image }): JSX.Element => (
    <Banner>
      <Image alt={image?.mobile?.alt} fluid={image?.mobile} screen={`<sm`} />
      <Image alt={image?.desktop?.alt} fluid={image?.desktop} screen={`md>`} />
      <StyledContainer width={`lg`}>
        <Title colour={`white`} italic>
          {title}
        </Title>
      </StyledContainer>
    </Banner>
  )
)
